import React from 'react';
import { SectionLabel } from './ui/SectionLabel';
import { CtaButton } from './ui/CtaButton';
const scenarios = [{
  need: 'Need a gentle class for tomorrow morning?',
  answer: 'It’s there.'
}, {
  need: 'Need something stronger and more dynamic?',
  answer: 'It’s there.'
}, {
  need: 'Need a complete 60-minute class?',
  answer: 'It’s there.'
}, {
  need: 'Need a different class so you don’t repeat last week?',
  answer: 'It’s there.'
}, {
  need: 'Need teaching cues and modifications?',
  answer: 'They’re already included.'
}, {
  need: 'Need to walk into class without planning from a blank page?',
  answer: 'Open. Choose. Teach.',
  emphasis: true
}];
export function NeedAClassSection() {
  return <section className="w-full bg-ivory py-10 sm:py-14 lg:py-18" aria-labelledby="need-heading" data-id="element-135" data-mp="2stfikaafpe8e">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-136" data-mp="vz19q9boxnd6">
        <div className="mx-auto max-w-2xl text-center" data-id="element-137" data-mp="r195qgxruasm">
          <div className="flex justify-center" data-id="element-138" data-mp="r1so1yrc3176">
            <SectionLabel data-id="element-139" data-mp="24nci0g95dgcn">In practice</SectionLabel>
          </div>
          <h2 id="need-heading" className="mt-3 font-serif text-[1.5rem] font-semibold uppercase leading-[1.1] text-ink sm:text-4xl" data-id="element-140" data-mp="24pylo4sx3bpl">
            Whatever you need to teach next,
            <span className="block text-forest" data-id="element-141" data-mp="1zosvadmqc0j8">start with a class that’s already built.</span>
          </h2>
        </div>

        <ul className="mx-auto mt-6 grid max-w-3xl gap-2 sm:grid-cols-2" data-id="element-142" data-mp="2ndtynmgpglhn">
          {scenarios.map(({
          need,
          answer,
          emphasis
        }) => <li key={need} className={`flex h-full flex-col items-center gap-1.5 rounded-2xl border px-4 py-3.5 text-center ${emphasis ? 'border-forest/25 bg-forest sm:col-span-2' : 'border-sandDark bg-cream/70'}`} data-id="element-143" data-mp="2scx4380lktq5">
              <span className={`text-[0.82rem] leading-snug ${emphasis ? 'text-ivory/75' : 'text-muted'} sm:text-[0.9rem]`} data-id="element-144" data-mp="36belknzwt9zm">
                {need}
              </span>
              <span className={`font-serif text-[0.8rem] font-semibold uppercase tracking-label ${emphasis ? 'text-goldSoft' : 'text-forest'} sm:text-sm`} data-id="element-145" data-mp="3g0ljjkih4a81">
                {answer}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-6 max-w-xl text-center text-[0.9rem] leading-relaxed text-ink sm:text-base" data-id="element-146" data-mp="3223zpxvovhve">
          120 complete classes means you don’t have to reinvent your teaching week after week.
        </p>

        <div className="mt-6" data-id="element-147" data-mp="2sbsjpcyqdi85">
          <CtaButton label="Get instant access" microcopy="One-Time Purchase • Instant Digital Access" data-id="element-148" data-mp="2s8wkzmf26pin" />
        </div>
      </div>
    </section>;
}